import { PROCEDURE_MEDIA, type MediaLang } from "@/lib/procedure-media";

/**
 * Small illustrative photo of Checkpoint Charlie, used alongside the
 * "two checkpoints" explanation on the insurance coverage pages. Alt text and
 * caption come from the shared media registry so the English and Spanish
 * pages stay in sync.
 */
export function CheckpointPhoto({ lang = "en" }: { lang?: MediaLang }) {
  const photo = PROCEDURE_MEDIA.checkpointCharlie;

  return (
    <figure className="my-6 mx-auto max-w-[16rem] md:float-right md:my-2 md:ml-6 md:mb-4 md:max-w-[13rem]">
      <img
        src={photo.src}
        srcSet={`${photo.webp} 1200w`}
        width={photo.width}
        height={photo.height}
        loading="lazy"
        decoding="async"
        alt={photo.alt[lang]}
        className="w-full rounded-2xl border border-border"
      />
      <figcaption className="mt-2 text-center text-xs text-muted-foreground">
        {photo.caption[lang]}
      </figcaption>
    </figure>
  );
}
